/* eslint-disable comma-dangle */
/* eslint-disable eqeqeq */
import React, { useState } from 'react';

// Sagas
import { connect, useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Card, CardBody, Button,
  Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import moment from 'moment';
import classnames from 'classnames';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { get } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';

function Tickets(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const dispatch = useDispatch();

  const [refresh, setRefresh] = useState(0);
  const [loadingMessages, setLoadingMessages] = useState(false);

  const activeTab = useSelector(
    (state) => state.CustomerService.techSupportActiveTab,
  );

  const user = JSON.parse(localStorage.getItem('authUser'));

  const checkForMessages = () => {
    const fetchData = async () => {
      try {
        await get(url.GET_CHECK_MESSAGES);

        setRefresh(refresh + 1);
      } catch (e) {
        toastr.warning(`${props.t('Could not get new messages')}: ${e.message}`);
      } finally {
        setLoadingMessages(false);
      }
    };

    setLoadingMessages(true);
    fetchData();
  };

  const toggle = (tab) => {
    dispatch({ type: 'UPDATE_TECH_SUPPORT_ACTIVE_TAB', payload: tab });
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Nav className="mt-4 mb-3" tabs>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: (activeTab === '1'),
              })}
              onClick={() => {
                toggle('1');
              }}
            >
              {t('My Subscriptions')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: (activeTab === '2'),
              })}
              onClick={() => {
                toggle('2');
              }}
            >
              {t('Fresh Tickets')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: (activeTab === '3'),
              })}
              onClick={() => {
                toggle('3');
              }}
            >
              {t('Completed')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: (activeTab === '4'),
              })}
              onClick={() => {
                toggle('4');
              }}
            >
              {t('All Tickets')}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent
          activeTab={activeTab}
        >
          <TabPane tabId="1">
            <Card>
              <CardBody>
                <Can i="see" this="Tech Support">
                  <Button color="warning" className="btn-soft-warning text-dark btn-sm" onClick={checkForMessages} disabled={loadingMessages}>{props.t('Check for Messages')}</Button>

                  {activeTab == '1' && (
                    <BaseGrid
                      url={url.GET_TICKETS}
                      hasSearch
                      shouldUpdate={refresh}
                      className="table table-hover table-bordered fs-6"
                      filters={`subscriberId=${user.id}&status=0`}
                      config={
                      {
                        rowClass: (ent) => {
                          if (ent.status == false && (
                            ent.messages.length === 0
                            || ent.messages[ent.messages.length - 1]
                              .from.toLowerCase().trim()
                              .includes(ent.email.toLowerCase().trim())
                          )) {
                            return 'table-danger';
                          }

                          if (ent.status == false) {
                            return 'table-warning';
                          }

                          return '';
                        },
                        columns: {
                          id: {
                            label: 'ID',
                            sort: true,
                            link: {
                              to: '/customer-service/ticket/%id%',
                            },
                          },
                          created_at: {
                            label: props.t('Created'),
                            date: {
                              format: (date) => (moment(date).fromNow()),
                              timezone: process.env.LOCAL_TZ,
                            },
                            sort: true,
                          },
                          name: { label: 'Name', sort: true },
                          email: { label: 'Email', sort: true },
                          brand: { label: 'Brand' },
                          model: { label: 'Model' },
                          version: { label: 'Version' },
                          symptoms: {
                            label: 'Symptoms',
                            badges: {
                              split: ',',
                              class: 'bg-info bg-soft text-dark p-1 mb-1',
                            },
                          },
                          subject: { label: 'Subject' },
                          subscribers: {
                            label: 'Subscribers',
                            format: (x) => (x.map((r) => (r.user.display_name))),
                            badges: {
                              class: 'bg-info bg-soft text-dark p-1',
                            },
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 30,
                        },
                      }
                      }
                    />
                  )}
                </Can>
                <Can not i="see" this="Tech Support"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </TabPane>

          <TabPane tabId="2">
            <Card>
              <CardBody>
                <Can i="see" this="Tech Support">
                  <Button color="warning" className="btn-soft-warning text-dark btn-sm" onClick={checkForMessages} disabled={loadingMessages}>{props.t('Check for Messages')}</Button>

                  {activeTab == '2' && (
                    <BaseGrid
                      url={url.GET_TICKETS}
                      hasSearch
                      shouldUpdate={refresh}
                      className="table table-hover table-bordered fs-6"
                      filters="hasSubs=0"
                      config={
                      {
                        rowClass: (ent) => {
                          if (ent.status == false && (
                            ent.messages.length === 0
                            || ent.messages[ent.messages.length - 1]
                              .from.toLowerCase().trim()
                              .includes(ent.email.toLowerCase().trim())
                          )) {
                            return 'table-danger';
                          }

                          if (ent.status == false) {
                            return 'table-warning';
                          }

                          return '';
                        },
                        columns: {
                          id: {
                            label: 'ID',
                            sort: true,
                            link: {
                              to: '/customer-service/ticket/%id%',
                            },
                          },
                          created_at: {
                            label: props.t('Created'),
                            date: {
                              format: (date) => (moment(date).fromNow()),
                              timezone: process.env.LOCAL_TZ,
                            },
                            sort: true,
                          },
                          name: { label: 'Name', sort: true },
                          email: { label: 'Email', sort: true },
                          brand: { label: 'Brand' },
                          model: { label: 'Model' },
                          version: { label: 'Version' },
                          symptoms: {
                            label: 'Symptoms',
                            badges: {
                              split: ',',
                              class: 'bg-info bg-soft text-dark p-1 mb-1',
                            },
                          },
                          subject: { label: 'Subject' },
                          subscribers: {
                            label: 'Subscribers',
                            format: (x) => (x.map((r) => (r.user.display_name))),
                            badges: {
                              class: 'bg-info bg-soft text-dark p-1',
                            },
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 30,
                        },
                      }
                      }
                    />
                  )}
                </Can>
                <Can not i="see" this="Tech Support"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </TabPane>

          <TabPane tabId="3">
            <Card>
              <CardBody>
                <Can i="see" this="Tech Support">
                  <Button color="warning" className="btn-soft-warning text-dark btn-sm" onClick={checkForMessages} disabled={loadingMessages}>{props.t('Check for Messages')}</Button>

                  {activeTab === '3' && (
                    <BaseGrid
                      url={url.GET_TICKETS}
                      hasSearch
                      shouldUpdate={refresh}
                      className="table table-hover table-bordered fs-6"
                      filters="status=1"
                      config={
                      {
                        rowClass: (ent) => {
                          if (ent.status == false && (
                            ent.messages.length === 0
                            || ent.messages[ent.messages.length - 1]
                              .from.toLowerCase().trim()
                              .includes(ent.email.toLowerCase().trim())
                          )) {
                            return 'table-danger';
                          }

                          if (ent.status == false) {
                            return 'table-warning';
                          }

                          return '';
                        },
                        columns: {
                          id: {
                            label: 'ID',
                            sort: true,
                            link: {
                              to: '/customer-service/ticket/%id%',
                            },
                          },
                          created_at: {
                            label: props.t('Created'),
                            date: {
                              format: (date) => (moment(date).fromNow()),
                              timezone: process.env.LOCAL_TZ,
                            },
                            sort: true,
                          },
                          name: { label: 'Name', sort: true },
                          email: { label: 'Email', sort: true },
                          brand: { label: 'Brand' },
                          model: { label: 'Model' },
                          version: { label: 'Version' },
                          symptoms: {
                            label: 'Symptoms',
                            badges: {
                              split: ',',
                              class: 'bg-info bg-soft text-dark p-1 mb-1',
                            },
                          },
                          subject: { label: 'Subject' },
                          subscribers: {
                            label: 'Subscribers',
                            format: (x) => (x.map((r) => (r.user.display_name))),
                            badges: {
                              class: 'bg-info bg-soft text-dark p-1',
                            },
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 30,
                        },
                      }
                      }
                    />
                  )}
                </Can>
                <Can not i="see" this="Tech Support"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </TabPane>

          <TabPane tabId="4">
            <Card>
              <CardBody>
                <Can i="see" this="Tech Support">
                  <Button color="warning" className="btn-soft-warning text-dark btn-sm" onClick={checkForMessages} disabled={loadingMessages}>{props.t('Check for Messages')}</Button>

                  {activeTab === '4' && (
                    <BaseGrid
                      url={url.GET_TICKETS}
                      hasSearch
                      shouldUpdate={refresh}
                      className="table table-hover table-bordered fs-6"
                      config={
                      {
                        rowClass: (ent) => {
                          if (ent.status == 0 && (
                            (ent.messages.length === 0)
                            || (ent.messages[ent.messages.length - 1]
                              .from.toLowerCase().trim()
                              .includes(ent.email.toLowerCase().trim())
                            )
                          )) {
                            return 'table-danger';
                          }

                          if (ent.status == false) {
                            return 'table-warning';
                          }

                          return '';
                        },
                        columns: {
                          id: {
                            label: 'ID',
                            sort: true,
                            link: {
                              to: '/customer-service/ticket/%id%',
                            },
                          },
                          created_at: {
                            label: props.t('Created'),
                            date: {
                              format: (date) => (moment(date).fromNow()),
                              timezone: process.env.LOCAL_TZ,
                            },
                            sort: true,
                          },
                          name: { label: 'Name', sort: true },
                          email: { label: 'Email', sort: true },
                          brand: { label: 'Brand' },
                          model: { label: 'Model' },
                          version: { label: 'Version' },
                          symptoms: {
                            label: 'Symptoms',
                            badges: {
                              split: ',',
                              class: 'bg-info bg-soft text-dark p-1 mb-1',
                            },
                          },
                          subject: { label: 'Subject' },
                          subscribers: {
                            label: 'Subscribers',
                            format: (x) => (x.map((r) => (r.user.display_name))),
                            badges: {
                              class: 'bg-info bg-soft text-dark p-1',
                            },
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 30,
                        },
                      }
                      }
                    />
                  )}
                </Can>
                <Can not i="see" this="Tech Support"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
}

Tickets.defaultProps = {
  t: (x) => (x),
};

Tickets.propTypes = {
  t: PropTypes.any,
};

export default connect(null, null)(withTranslation()(Tickets));
